import { useEffect, useState } from 'react';
import useTitle from '../hooks/useTitle';

export type HealthType = {
	healthy: boolean;
	message: string;
	build?: string;
};

const HealthPage: React.FC = () => {
	useTitle('Health Information');
	const [healthCheck, setHealthCheck] = useState<HealthType | null>(null);
	const [loading, setLoading] = useState(false);

	useEffect(() => {
		getHealthCheck();
		const interval = setInterval(() => {
			getHealthCheck();
		}, 5000);

		return () => {
			clearInterval(interval);
			// Cleanup logic if needed
		};
	}, []);

	const getHealthCheck = async () => {
		setLoading(true);
		const response = await fetch('/api/System/HealthCheck', {
			method: 'GET',
			headers: {
				'Content-Type': 'application/json',
			},
		});

		if (!response.ok) {
			setLoading(false);
			throw new Error(`Server returned error status ${response.status}`);
		}

		const result = await response.json();
		console.log(result);

		setHealthCheck(result);
		setLoading(false);
	};

	return (
		<div className='flex flex-col items-center justify-center min-h-screen py-2'>
			<h1 className='text-4xl font-bold mb-4'>Health Check</h1>
			{loading ? (
				<p className='text-lg'>Loading...</p>
			) : healthCheck ? (
				<>
					<p className='text-lg'>{healthCheck.message}</p>
					<p className='text-lg'>{healthCheck.build}</p>
					<p className='text-lg'>The system is running smoothly.</p>
				</>
			) : (
				<p className='text-lg'>The system is NOT running smoothly.</p>
			)}
		</div>
	);
};

export default HealthPage;
